import { makeVar } from '@apollo/client';
import { User } from '@types';

const loggedInUser = makeVar<Nullable<User>>(null);

export default loggedInUser;
